import { gql } from "@apollo/client";
import {
  ATTACHMENT_FIELDS,
  CORE_MISSION_FIELDS,
  INTERVIEW_QUESTION_FIELDS,
  CORE_MISSION_ROLE_FIELDS_WITH_FILTERED_CHALLENGES,
  RATE_RANGE_FIELDS,
} from "graphql/fragments";

const GET_MISSION_ROLE = gql`
  ${CORE_MISSION_FIELDS}
  ${CORE_MISSION_ROLE_FIELDS_WITH_FILTERED_CHALLENGES}
  ${RATE_RANGE_FIELDS}
  ${ATTACHMENT_FIELDS}
  query GetMissionRole(
    $slug: ID!
    $includeCustomerBudget: Boolean = false
    $includeAttachments: Boolean = false
    $includeDisabledChallenges: Boolean = false
  ) {
    missionRole(slug: $slug) {
      ...MissionRoleFieldsWithFilteredChallenges
      missionRoleChallenges {
        id
        challenge {
          id
          name
        }
        enabled
        responsesCount
      }
      attachments @include(if: $includeAttachments) {
        ...AttachmentFields
      }
      customerBudget @include(if: $includeCustomerBudget) {
        ...RateRangeFields
      }
      mission {
        ...MissionFields
      }
      missionRoleApplicant {
        uuid
        message
        profile {
          id
          description
          archetype
        }
        state
        appliedAt
      }
      applicantApplied
    }
  }
`;

const GET_ATS_REPORT_FOR_MISSION_ROLE = gql`
  query AtsReportForMissionRole($slug: ID!, $mode: AtsReportMode!) {
    atsReportForMissionRole(slug: $slug, mode: $mode) {
      applicationsReceived
      applicationsWithdrawn
      applicationsMovedToInReview
      applicationsMovedToSelected
      applicationsMovedToNotSelected
      applicationsMovedToShortlisted
      applicationsMovedToInterviewing
      invitationsAccepted
      invitationsSent
    }
  }
`;

const GET_MISSION_ROLE_INTERVIEW = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  query GetMissionRoleInterview($missionRoleId: ID!) {
    missionRoleInterview(missionRoleId: $missionRoleId) {
      id
      uuid
      type
      name
      description
      timeLimit
      videoUrl
      thumbnailUrl
      introVideoUrl
      questions {
        ...InterviewQuestionFields
      }
    }
  }
`;

export { GET_MISSION_ROLE, GET_ATS_REPORT_FOR_MISSION_ROLE, GET_MISSION_ROLE_INTERVIEW };
